import React from 'react';
import Header from '../components/Header';

const PublicLayout = (props) => {
	return (
		<>
			<Header showUserSection={false} />
			<div className='base-container'>{props.children}</div>
		</>
	);
};

export default PublicLayout;
